import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import AnswerChoice from "./AnswerChoice";
import FillBlank from "./FillBlank";
import { formatContext } from "../../utils/assignments/formatContext";
import "../../styles/questionColumn.css";

const normalize = (v) => {
  if (v == null) return null;
  const s = String(v).trim();
  return s === "" ? null : s;
};

const normalizeLetter = (v) => {
  const s = normalize(v);
  if (s == null) return null;
  return s.toUpperCase();
};

const QuestionColumn = ({
  question,
  questionIndex,
  totalQuestions,
  selectedAnswer,
  isMarked,
  setAnswer,
  toggleMark,
  isReadOnly,
  isDiagnostic = false,
}) => {
  if (!question) return null;

  const choicesObj = question.choices ?? {};
  const isMultipleChoice = Object.keys(choicesObj).length > 0;

  const correctAnswerRaw = question.correctAnswer ?? null;

  const studentVal = isMultipleChoice
    ? normalizeLetter(selectedAnswer)
    : normalize(selectedAnswer);

  const correctVal = isMultipleChoice
    ? normalizeLetter(correctAnswerRaw)
    : normalize(correctAnswerRaw);

  const hasStudentAnswer = studentVal != null;
  const hasCorrectAnswer = correctVal != null;

  const isReviewMode = Boolean(isReadOnly && hasStudentAnswer && hasCorrectAnswer);
  const isCorrect = isReviewMode ? studentVal === correctVal : null;
  const isIncorrect = isReviewMode ? studentVal !== correctVal : null;

  return (
    <div className="question-column">
      {/* Top strip */}
      <div className="question-strip">
        <div className="question-number-box">{questionIndex + 1}</div>

        {!isReadOnly && !isDiagnostic && (
          <div className="mark-for-review" onClick={toggleMark}>
            {isMarked ? (
              <BookmarkIcon className="bookmark active" />
            ) : (
              <BookmarkBorderIcon className="bookmark" />
            )}
            <span>Mark for Review</span>
          </div>
        )}
      </div>

      <div className="question-strip-dashed" />

      <div className="question-prompt">
        {question.questionText ? formatContext(question.questionText) : null}
      </div>

      <div className="answer-choices">
        {/* Multiple choice */}
        {isMultipleChoice &&
          ["A", "B", "C", "D"].map((letter) => {
            const text = choicesObj?.[letter];
            if (!text) return null;

            const isSelected = normalizeLetter(selectedAnswer) === letter;

            const isCorrectSelected =
              isReviewMode && isCorrect === true && isSelected;

            const isIncorrectSelected =
              isReviewMode && isIncorrect === true && isSelected;

            const isCorrectChoice =
              isReviewMode && isIncorrect === true && correctVal === letter;

            return (
              <AnswerChoice
                key={letter}
                label={letter}
                text={text}
                selected={isSelected}
                disabled={isReadOnly}
                onClick={isReadOnly ? undefined : () => setAnswer(letter)}
                isCorrectSelected={isCorrectSelected}
                isIncorrectSelected={isIncorrectSelected}
                isCorrectChoice={isCorrectChoice}
              />
            );
          })}

        {/* Fill in the blank */}
        {!isMultipleChoice && (
          <>
            {/* In-progress mode: keep the input UI */}
            {!isReadOnly && (
              <FillBlank
                value={selectedAnswer}
                disabled={isReadOnly}
                onChange={(val) => setAnswer(val)}
              />
            )}

            {/* Review mode: show a bigger review card ONLY */}
            {isReadOnly && (
              <div className="fillblank-review fillblank-review-lg">
                <div
                  className={[
                    "fillblank-review-row",
                    isCorrect === false ? "wrong" : "correct",
                  ].join(" ")}
                >
                  <strong>Your answer:</strong> <span>{studentVal ?? ""}</span>
                </div>

                <div className="fillblank-review-row correct">
                  <strong>Correct answer:</strong> <span>{correctVal ?? ""}</span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default QuestionColumn;
